
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fale-conosco",
      function () {
        return require("private-next-pages/fale-conosco/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/fale-conosco"])
      });
    }
  